export default {
    state: {
        //用户id
        user_id: JSON.parse(window.sessionStorage.getItem('user_id')),
        //用户名
        user_name: JSON.parse(window.sessionStorage.getItem('user_name')),
        //角色id
        role_id: JSON.parse(window.sessionStorage.getItem('role_id')),
        //角色名称
        role_name: JSON.parse(window.sessionStorage.getItem('role_name')),
        //验证token
        auth_key: JSON.parse(window.sessionStorage.getItem('auth_key')),
        //项目列表
        project_list: JSON.parse(window.sessionStorage.getItem('project_list')),
        //功能列表
        func_list: JSON.parse(window.sessionStorage.getItem('function_list')),
        //权限列表
        check_auth_list: JSON.parse(window.sessionStorage.getItem('check_auth_list')),
        //ibms的项目名称
        ibmsProName: JSON.parse(window.sessionStorage.getItem('ibmsProName')),
        //ibms的项目id
        ibmsProId: JSON.parse(window.sessionStorage.getItem('ibmsProId')),
    },
    mutations: {
        //写入验证token
        get_auth_key(state, data) {
            state.auth_key = data
            window.sessionStorage.setItem('auth_key', JSON.stringify(data))
        },
        //写入验证权限
        checkAuthList(state, data) {
            state.check_auth_list = data
            window.sessionStorage.setItem('check_auth_list', JSON.stringify(data))
        },
        //写入验证功能
        funcList(state, data) {
            state.func_list = data
            window.sessionStorage.setItem('func_list', JSON.stringify(data))
        },
        //写入验证项目
        projectList(state, data) {
            state.project_list = data
            window.sessionStorage.setItem('project_list', JSON.stringify(data))
        },
        //ibms的项目名称
        get_ibmsProNameData(state, data) {
            state.ibmsProName = data
            window.sessionStorage.setItem('ibmsProName', JSON.stringify(data))
        },
        //ibms的项目名称
        get_ibmsProIdData(state, data) {
            state.ibmsProId = data
            window.sessionStorage.setItem('ibmsProId', JSON.stringify(data))
        },
        //写入用户id
        get_user_id(state, data) {
            state.user_id = data
            window.sessionStorage.setItem('user_id', JSON.stringify(data))
        },
        //写入用户名
        get_user_name(state, data) {
            state.user_name = data
            window.sessionStorage.setItem('user_id', JSON.stringify(data))
        },
        //写入角色id
        get_role_id(state, data) {
            state.role_id = data
            window.sessionStorage.setItem('role_id', JSON.stringify(data))
        },
        //写入角色name
        get_role_name(state, data) {
            state.role_name = data
            window.sessionStorage.setItem('role_name', JSON.stringify(data))
        },
    },
    actions: {},
    getters: {}
}